import { ChevronRightIcon, HamburgerIcon, SearchIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Link as ChakraLink,
  Collapse,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Text,
  VStack,
  WrapItem,
  useDisclosure,
} from "@chakra-ui/react";
import Icon from "@modules/Icon";
import SearchBar from "@modules/Search/component/SearchBar";
import useSearchBar from "@modules/Search/hooks/useSearchBar";
import { Link, navigate } from "gatsby";
import React from "react";
import { Else, If, Then } from "react-if";
import { MobileLinkSections } from "../models/linkSection";
import { IDropMobileListItem, IMobileSections } from "../models/type";
import { HomeLogoNavLink, HomeLogoSquareHero } from "../style";

const MobileHeader = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleGotoLink = (slug: string) => () => {
    onClose();
    navigate(`/${slug}`);
  };

  const { isShowSearch, handleSearchBar } = useSearchBar();

  return (
    <Box>
      <HStack bg={"white"} justifyContent={"space-between"} px={4} py={4}>
        <HomeLogoSquareHero to="/" aria-label="home">
          <Icon name="logoSquare" />
        </HomeLogoSquareHero>

        <HStack>
          <IconButton
            borderWidth={0}
            borderColor={"transparent"}
            size="lg"
            color={"black"}
            icon={<SearchIcon boxSize={6} />}
            aria-label={"Open Menu"}
            onClick={handleSearchBar}
          />

          <IconButton
            borderWidth={0}
            borderColor={"transparent"}
            size="lg"
            color={"black"}
            icon={<HamburgerIcon boxSize={10} />}
            aria-label={"Open Menu"}
            onClick={isOpen ? onClose : onOpen}
          />
        </HStack>
      </HStack>

      <Collapse in={isShowSearch} animateOpacity>
        <Box height={isShowSearch ? "auto" : 0}>
          <SearchBar />
        </Box>
      </Collapse>

      <Drawer placement={"right"} onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent maxW={"90vw"}>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">
            <HomeLogoNavLink to="/" aria-label="home">
              <Icon name="logo" />
            </HomeLogoNavLink>
          </DrawerHeader>
          <DrawerBody>
            <Flex direction="column" h="100%">
              <Box flexGrow={1}>
                <Accordion allowToggle bg="white">
                  {Object.keys(MobileLinkSections).map((sectionKey, index) => {
                    const section =
                      MobileLinkSections[sectionKey as keyof IMobileSections];
                    return (
                      <AccordionItem
                        key={index}
                        bg="white"
                        border={"none"}
                        borderWidth={0}
                        borderColor={"transparent"}
                      >
                        <AccordionButton
                          px={0}
                          mb={4}
                          borderWidth={0}
                          borderColor={"transparent"}
                        >
                          <Box as="span" flex="1" textAlign="left">
                            <Text textStyle={"h4"} color={"misc700"}>
                              {section.text}
                            </Text>
                          </Box>
                          <ChevronRightIcon boxSize={8} />
                        </AccordionButton>

                        <AccordionPanel pb={4} px={0}>
                          <If condition={section.dropListItem != undefined}>
                            <Then>
                              <VStack alignItems={"start"}>
                                {section.dropListItem?.map(
                                  (
                                    item: IDropMobileListItem,
                                    index: number
                                  ) => (
                                    <WrapItem py={2} key={index}>
                                      <If condition={item.isExternal}>
                                        <Then>
                                          <ChakraLink
                                            href={`${item.slug}`}
                                            fontSize={"m"}
                                            color={"black"}
                                            _hover={{ textDecoration: "none" }}
                                          >
                                            {item.name}
                                          </ChakraLink>
                                        </Then>
                                        <Else>
                                          <Link to={`${item.slug}`}>
                                            {item.name}
                                          </Link>
                                        </Else>
                                      </If>
                                    </WrapItem>
                                  )
                                )}
                              </VStack>
                            </Then>
                          </If>
                        </AccordionPanel>
                      </AccordionItem>
                    );
                  })}
                </Accordion>

                <Box mb={4} onClick={handleGotoLink("contact-us")}>
                  <Text textStyle={"h4"} color={"misc700"}>
                    Contact Us
                  </Text>
                </Box>
                <Box mb={4} onClick={handleGotoLink("our-blog")}>
                  <Text textStyle={"h4"} color={"misc700"}>
                    Blog
                  </Text>
                </Box>
              </Box>

              <Box>
                <Link to={"/request-a-demo"}>
                  <Button variant="primary" width={"full"}>
                    Request a Demo
                  </Button>
                </Link>
              </Box>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default MobileHeader;
